<template>
  <div class="page-wrapper main-page-container">
    <div class="main-page-header">
      <div class="display-text">
        Resources
      </div>
      <div class="heading-text">
        Downloadable assets for branding and product representation
      </div>
    </div>
    <div class="header-divider">
      <div class="caption-text">
        <span class="emoji">👈</span> Explore the menu on the left or see the highlighted content below
      </div>
      <hr>
    </div>
    <div class="group-section">
      <div class="section-title"><span class="section-title-text">Other resources</span></div>
      <div class="button-container">
        <a @click="navigateTo('/resources/other-resources/design-assets/mascots')" class="main-page-button"><div class="button-icon">🔥</div><div class="button-text"><span class="block-title">Design assets</span><span class="menu-title">Mascots</span></div><SvgIcon class="button-arrow" name="IconArrowChevronRight" :width="20"/></a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    navigateTo (path) {
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss">

.main-page-container {
  display: flex;
  flex-direction: column;
  gap: 32px;

  img {
    width: 500px;
    margin-bottom: -64px;
  }
  .main-page-header {
    display: flex;
    flex-direction: column;
    gap: 8px;

    hr {
      margin: 12px 0;
      padding: 0;
      border-top: 1px solid $color-cool-grey-100;
    }

    .display-text {
      font: $font-style-display-lg-bold;
      color: $color-cool-grey-900;
    }

    .heading-text {
      font: $font-style-heading-md-reg;
      color: $color-cool-grey-700;
    }
  }

  .header-divider {
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: center;

    hr {
      flex-grow: 1;
    }
  }

  .caption-text {
    font: $font-style-title-md-reg;
    color: $color-cool-grey-700;
  }

  .group-section {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .section-title {
      display: flex;
      flex-direction: row;
      gap: 8px;
      align-items: center;

      .section-title-text {
        font: $font-style-title-lg-med;
        color: $color-cool-grey-900;
      }
    }
  }

  .button-container {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    gap: 16px;
    row-gap: 16px;

    .main-page-button {
      border-radius: 16px;
      padding: 16px 16px;
      border: 1px solid $color-cool-grey-100;
      display: flex;
      flex-direction: row;
      gap: 16px;
      align-items: flex-start;
      box-sizing: border-box;
      flex: 0 1 calc((100% - (16px * 1)) / 2);

      @media screen and (max-width: 559px) {
        flex: 0 1 100%;
      }

      &:hover {
        background-color: $color-cool-grey-50;
        color: $color-cool-grey-900;
        border-color: $color-cool-grey-50;
      }

      .button-icon {
        display: flex;
        flex-direction: row;
        flex: 0 0 45px;
        height: 45px;
        justify-content: center;
        align-items: center;
        background-color: $color-cool-grey-100;
        border-radius: 12px;
        font-size: 20px;
      }

      .button-text {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;
        align-items: stretch;
        overflow: hidden;

        .block-title{
          font: $font-style-functional-md-reg;
          color: $color-cool-grey-500;
        }
        .menu-title{
          font: $font-style-functional-lg-med;
          color: $color-cool-grey-900;
        }
      }

      .button-arrow {
        display: none;
        margin-right: -4px;
        flex: 0 0 20px;
        height: 20px;
      }
    }
  }

  .footer-text {
    margin-top: 32px;
    text-align: center;
    font: $font-style-functional-lg-reg;
    color: $color-cool-grey-700;
  }
}

.emoji {
  font-size: 1.4em;
  vertical-align: middle;
}

</style>
